/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, HFlow, Icon, Text, Tooltip, VFlow } from 'bold-ui'
import { EditableRow } from 'view/atendimentos/detail/components/EditableList'

import { getParteBucal } from '../../../util'
import { EvolucoesPeriodontaisFieldModel } from '../EvolucoesPeriodontaisField'

export interface EvolucoesPeriodontaisTableRowProps {
  item: EvolucoesPeriodontaisFieldModel
  updateItem(item: EvolucoesPeriodontaisFieldModel): void
  removeItem(item: EvolucoesPeriodontaisFieldModel): void
}

export default function EvolucoesPeriodontaisTableRow(props: EvolucoesPeriodontaisTableRowProps) {
  const { item, updateItem, removeItem } = props

  return (
    <EditableRow editing={false}>
      <Grid
        style={css`
          margin: 0;
        `}
      >
        <Cell size={3} alignSelf='center'>
          <Text>{getParteBucal(item.sextante).title}</Text>
        </Cell>

        <Cell size={7} alignSelf='center'>
          <VFlow vSpacing={0}>
            {item.procedimentos.map((proced) => (
              <Text key={proced.id}>
                {proced.descricao} - {proced.codigo}
              </Text>
            ))}
          </VFlow>
        </Cell>

        <Cell size={2} alignSelf='center'>
          <HFlow hSpacing={0.5} justifyContent='flex-end'>
            <Tooltip text='Editar'>
              <Button size='small' skin='ghost' onClick={() => updateItem(item)}>
                <Icon icon='penOutline' />
              </Button>
            </Tooltip>
            <Tooltip text='Excluir'>
              <Button size='small' skin='ghost' onClick={() => removeItem(item)}>
                <Icon icon='trashOutline' />
              </Button>
            </Tooltip>
          </HFlow>
        </Cell>
      </Grid>

      {!!item?.observacao?.trim().length && (
        <HFlow
          hSpacing={0.2}
          style={css`
            padding-bottom: 0.5rem;
          `}
        >
          <Text fontWeight='bold'>Observações: </Text>
          <Text
            fontStyle='italic'
            style={css`
              word-break: break-all;
            `}
          >
            <div dangerouslySetInnerHTML={{ __html: item.observacao }} />
          </Text>
        </HFlow>
      )}
    </EditableRow>
  )
}
